import { render, staticRenderFns } from "./MaterialsDownload.vue?vue&type=template&id=88d5ddc0&scoped=true"
import script from "./MaterialsDownload.vue?vue&type=script&lang=js"
export * from "./MaterialsDownload.vue?vue&type=script&lang=js"
import style0 from "./MaterialsDownload.vue?vue&type=style&index=0&id=88d5ddc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d5ddc0",
  null
  
)

export default component.exports